module.exports = __webpack_public_path__ + "static/background-1f5c35f8ecc374f213647ddc894bde6d.jpg";